import { render, staticRenderFns } from "./OtherOfficeConnectionList.vue?vue&type=template&id=08182020&scoped=true&lang=pug"
import script from "./OtherOfficeConnectionList.vue?vue&type=script&lang=ts"
export * from "./OtherOfficeConnectionList.vue?vue&type=script&lang=ts"
import style0 from "./OtherOfficeConnectionList.vue?vue&type=style&index=0&id=08182020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08182020",
  null
  
)

export default component.exports